/**
 * Generated from hh_ch2_72dpi_p03-04.fla
 */
export function hh_ch2_72dpi_p0304(this: Ihh_ch2_72dpi_p0304) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1.call(holly[0] as Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1);
		holly[0].x = 394.25;
		holly[0].y = 768;
		holly[0].width = 303.50;
		holly[0].height = 509.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2.call(holly[1] as Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2);
		holly[1].x = 394.25;
		holly[1].y = 768;
		holly[1].width = 303.50;
		holly[1].height = 509.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const bg = this.bg;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const piper = this.piper;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_piper.call(this.piper);
	piper.x = 553.75;
	piper.y = 768;
	piper.width = 250.50;
	piper.height = 512.50;
	piper.alpha = 1.00;
	if (piper.onLayout) piper.onLayout();
	const amy = this.amy;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_amy.call(this.amy);
	amy.x = 1101.25;
	amy.y = 768;
	amy.width = 239.50;
	amy.height = 504.00;
	amy.alpha = 1.00;
	if (amy.onLayout) amy.onLayout();
	const chairHolly = this.chairHolly;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairholly.call(this.chairHolly);
	chairHolly.x = 286;
	chairHolly.y = 768;
	chairHolly.width = 95.00;
	chairHolly.height = 188.50;
	chairHolly.alpha = 1.00;
	if (chairHolly.onLayout) chairHolly.onLayout();
	const chairOscar = this.chairOscar;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairoscar.call(this.chairOscar);
	chairOscar.x = 1339.25;
	chairOscar.y = 768;
	chairOscar.width = 132.50;
	chairOscar.height = 194.00;
	chairOscar.alpha = 1.00;
	if (chairOscar.onLayout) chairOscar.onLayout();
	const oscar = this.oscar;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscar.call(this.oscar);
	oscar.x = 1230.5;
	oscar.y = 768;
	oscar.width = 244.00;
	oscar.height = 605.00;
	oscar.alpha = 1.00;
	if (oscar.onLayout) oscar.onLayout();
	const table = this.table;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_table.call(this.table);
	table.x = 836;
	table.y = 768;
	table.width = 794.00;
	table.height = 166.00;
	table.alpha = 1.00;
	if (table.onLayout) table.onLayout();
	const phoneGlow = this.phoneGlow;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phoneglow.call(this.phoneGlow);
	phoneGlow.x = 732.75;
	phoneGlow.y = 464.5;
	phoneGlow.width = 221.50;
	phoneGlow.height = 203.00;
	phoneGlow.alpha = 1.00;
	if (phoneGlow.onLayout) phoneGlow.onLayout();
	const phoneArm = this.phoneArm;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phonearm.call(this.phoneArm);
	phoneArm.x = 281;
	phoneArm.y = 608;
	phoneArm.width = 486.00;
	phoneArm.height = 261.50;
	phoneArm.alpha = 1.00;
	if (phoneArm.onLayout) phoneArm.onLayout();
	const phoneHitArea = this.phoneHitArea;
	phoneHitArea.push(830.58,558.48,726.65,601.52,622.72,558.48,579.68,454.55,622.72,350.62,726.65,307.58,830.58,350.62,873.62,454.55);
	const holly1Arms = this.holly1Arms;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1frontarm.call(this.holly1Arms);
	holly1Arms.x = 444.5;
	holly1Arms.y = 691;
	holly1Arms.width = 140.00;
	holly1Arms.height = 96.00;
	holly1Arms.alpha = 1.00;
	if (holly1Arms.onLayout) holly1Arms.onLayout();
	const oscarArms = this.oscarArms;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscararms.call(this.oscarArms);
	oscarArms.x = 1243;
	oscarArms.y = 678.5;
	oscarArms.width = 300.50;
	oscarArms.height = 333.50;
	oscarArms.alpha = 1.00;
	if (oscarArms.onLayout) oscarArms.onLayout();
	const frameLeft = this.frameLeft;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 515.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const frameRight = this.frameRight;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 416.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const lines = this.lines;
	hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframelines.call(this.lines);
	lines.x = 832;
	lines.y = 383.75;
	lines.width = 1664.00;
	lines.height = 767.50;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_bg(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_piper(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_piper) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_piper", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_amy(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_amy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_amy", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairholly(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairholly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_chairholly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairoscar(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairoscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_chairoscar", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscar(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_oscar", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_holly2", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_holly1", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_table(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_table) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_table", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phoneglow(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phoneglow) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_holly2phoneglow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phonearm(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phonearm) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_holly2phonearm", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_circle(this: Ihh_ch2_72dpi_p0304_circle) {
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1frontarm(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1frontarm) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_holly1frontarm", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscararms(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscararms) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p03_oscararms", 1.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeLframe(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeRframe(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframelines(this: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframelines) {
	if (this.setLayoutTexture) this.setLayoutTexture("lines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
interface Ihh_ch2_72dpi_p0304Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch2_72dpi_p0304Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch2_72dpi_p0304Sprite extends Ihh_ch2_72dpi_p0304Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch2_72dpi_p0304Text extends Ihh_ch2_72dpi_p0304Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch2_72dpi_p0304Polygon extends Array<number> {
}
interface Ihh_ch2_72dpi_p0304 {
	readonly holly: Ihh_ch2_72dpi_p0304Array<Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1|Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2>;
	readonly bg: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_bg;
	readonly piper: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_piper;
	readonly amy: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_amy;
	readonly chairHolly: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairholly;
	readonly chairOscar: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairoscar;
	readonly oscar: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscar;
	readonly table: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_table;
	readonly phoneGlow: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phoneglow;
	readonly phoneArm: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phonearm;
	readonly phoneHitArea: Ihh_ch2_72dpi_p0304_circle;
	readonly holly1Arms: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1frontarm;
	readonly oscarArms: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscararms;
	readonly frameLeft: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeLframe;
	readonly frameRight: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeRframe;
	readonly lines: Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframelines;
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_bg extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_piper extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_amy extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairholly extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_chairoscar extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscar extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly2 extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1 extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_table extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phoneglow extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAsset1P3P4chp2_p03_holly2phonearm extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_circle extends Ihh_ch2_72dpi_p0304Polygon {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_holly1frontarm extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_oscararms extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeLframe extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframeRframe extends Ihh_ch2_72dpi_p0304Sprite {
}
interface Ihh_ch2_72dpi_p0304_hh_ch2_72dpi_p0304psdAssetP3P4chp2_p03_wcframelines extends Ihh_ch2_72dpi_p0304Sprite {
}
